module.exports = __webpack_public_path__ + "static/media/kuwait-flag-round.a40da141.jpg";